import moment from "moment-timezone";

const TIMEZONE_MAP = {
  "(UTC+03:00) Doha": "Asia/Qatar",
  "(UTC-12:00) International Date Line West": "Etc/GMT+12",
  "(UTC-11:00) Coordinated Universal Time-11": "Etc/GMT+11",
  "(UTC-10:00) Hawaii": "Pacific/Honolulu",
  "(UTC-09:00) Alaska": "America/Anchorage",
  "(UTC-08:00) Baja California": "America/Tijuana",
  "(UTC-07:00) Pacific Daylight Time (US & Canada)": "America/Los_Angeles",
  "(UTC-08:00) Pacific Standard Time (US & Canada)": "America/Los_Angeles",
  "(UTC-07:00) Arizona": "America/Phoenix",
  "(UTC-07:00) Chihuahua, La Paz, Mazatlan": "America/Chihuahua",
  "(UTC-07:00) Mountain Time (US & Canada)": "America/Denver",
  "(UTC-06:00) Central America": "America/Guatemala",
  "(UTC-06:00) Central Time (US & Canada)": "America/Chicago",
  "(UTC-06:00) Guadalajara, Mexico City, Monterrey": "America/Mexico_City",
  "(UTC-06:00) Saskatchewan": "America/Regina",
  "(UTC-05:00) Bogota, Lima, Quito": "America/Bogota",
  "(UTC-05:00) Eastern Time (US & Canada)": "America/New_York",
  "(UTC-04:00) Eastern Daylight Time (US & Canada)": "America/New_York",
  "(UTC-05:00) Indiana (East)": "America/Indiana/Indianapolis",
  "(UTC-04:00) Asuncion": "America/Asuncion",
  "(UTC-04:00) Atlantic Time (Canada)": "America/Halifax",
  "(UTC-04:00) Cuiaba": "America/Cuiaba",
  "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan": "America/La_Paz",
  "(UTC-04:00) Santiago": "America/Santiago",
  "(UTC-03:30) Newfoundland": "America/St_Johns",
  "(UTC-03:00) Brasilia": "America/Sao_Paulo",
  "(UTC-03:00) Buenos Aires": "America/Argentina/Buenos_Aires",
  "(UTC-03:00) Cayenne, Fortaleza": "America/Fortaleza",
  "(UTC-03:00) Montevideo": "America/Montevideo",
  "(UTC-03:00) Salvador": "America/Bahia",
  "(UTC-02:00) Mid-Atlantic - Old": "America/Noronha",
  "(UTC-01:00) Azores": "Atlantic/Azores",
  "(UTC-01:00) Cape Verde Is.": "Atlantic/Cape_Verde",
  "(UTC) Coordinated Universal Time": "Etc/UTC",
  "(UTC) Edinburgh, London": "Europe/London",
  "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna":
    "Europe/Berlin",
  "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague":
    "Europe/Belgrade",
  "(UTC+01:00) Brussels, Copenhagen, Madrid, Paris": "Europe/Paris",
  "(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb": "Europe/Warsaw",
  "(UTC+01:00) West Central Africa": "Africa/Lagos",
  "(UTC+02:00) Windhoek": "Africa/Windhoek",
  "(UTC+02:00) Athens, Bucharest": "Europe/Athens",
  "(UTC+02:00) Beirut": "Asia/Beirut",
  "(UTC+02:00) Cairo": "Africa/Cairo",
  "(UTC+03:00) Damascus": "Asia/Damascus",
  "(UTC+02:00) E. Europe": "Europe/Chisinau",
  "(UTC+02:00) Harare, Pretoria": "Africa/Johannesburg",
  "(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius":
    "Europe/Helsinki",
  "(UTC+03:00) Istanbul": "Europe/Istanbul",
  "(UTC+02:00) Jerusalem": "Asia/Jerusalem",
  "(UTC+02:00) Tripoli": "Africa/Tripoli",
  "(UTC+03:00) Amman": "Asia/Amman",
  "(UTC+03:00) Baghdad": "Asia/Baghdad",
  "(UTC+02:00) Kaliningrad": "Europe/Kaliningrad",
  "(UTC+03:00) Kuwait, Riyadh": "Asia/Riyadh",
  "(UTC+03:00) Nairobi": "Africa/Nairobi",
  "(UTC+03:00) Moscow, St. Petersburg, Volgograd, Minsk": "Europe/Moscow",
  "(UTC+04:00) Samara, Ulyanovsk, Saratov": "Europe/Samara",
  "(UTC+03:30) Tehran": "Asia/Tehran",
  "(UTC+04:00) Abu Dhabi, Muscat": "Asia/Dubai",
  "(UTC+04:00) Baku": "Asia/Baku",
  "(UTC+04:00) Port Louis": "Indian/Mauritius",
  "(UTC+04:00) Tbilisi": "Asia/Tbilisi",
  "(UTC+04:00) Yerevan": "Asia/Yerevan",
  "(UTC+04:30) Kabul": "Asia/Kabul",
  "(UTC+05:00) Ashgabat, Tashkent": "Asia/Tashkent",
  "(UTC+05:00) Yekaterinburg": "Asia/Yekaterinburg",
  "(UTC+05:00) Islamabad, Karachi": "Asia/Karachi",
  "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi": "Asia/Kolkata",
  "(UTC+05:30) Sri Jayawardenepura": "Asia/Colombo",
  "(UTC+05:45) Kathmandu": "Asia/Kathmandu",
  "(UTC+06:00) Nur-Sultan (Astana)": "Asia/Almaty",
  "(UTC+06:00) Dhaka": "Asia/Dhaka",
  "(UTC+06:30) Yangon (Rangoon)": "Asia/Yangon",
  "(UTC+07:00) Bangkok, Hanoi, Jakarta": "Asia/Bangkok",
  "(UTC+07:00) Novosibirsk": "Asia/Novosibirsk",
  "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi": "Asia/Shanghai",
  "(UTC+08:00) Krasnoyarsk": "Asia/Krasnoyarsk",
  "(UTC+08:00) Kuala Lumpur, Singapore": "Asia/Kuala_Lumpur",
  "(UTC+08:00) Manila, Philippines": "Asia/Manila",
  "(UTC+08:00) Perth": "Australia/Perth",
  "(UTC+08:00) Taipei": "Asia/Taipei",
  "(UTC+08:00) Ulaanbaatar": "Asia/Ulaanbaatar",
  "(UTC+08:00) Irkutsk": "Asia/Irkutsk",
  "(UTC+09:00) Osaka, Sapporo, Tokyo": "Asia/Tokyo",
  "(UTC+09:00) Seoul": "Asia/Seoul",
  "(UTC+09:30) Adelaide": "Australia/Adelaide",
  "(UTC+09:30) Darwin": "Australia/Darwin",
  "(UTC+10:00) Brisbane": "Australia/Brisbane",
  "(UTC+10:00) Guam, Port Moresby": "Pacific/Port_Moresby",
  "(UTC+09:00) Yakutsk": "Asia/Yakutsk",
  "(UTC+11:00) Solomon Is., New Caledonia": "Pacific/Guadalcanal",
  "(UTC+12:00) Coordinated Universal Time+12": "Etc/GMT-12",
  "(UTC+12:00) Fiji": "Pacific/Fiji",
  "(UTC+11:00) Magadan": "Asia/Magadan",
  "(UTC+12:00) Petropavlovsk-Kamchatsky - Old": "Asia/Kamchatka",
  "(UTC+13:00) Nuku'alofa": "Pacific/Tongatapu",
  "(UTC+13:00) Samoa": "Pacific/Apia",
} as const;

export const getTimezoneDetails = (timezone: keyof typeof TIMEZONE_MAP) => {
  const ianaTimezone = TIMEZONE_MAP[timezone];
  const momentTimezone = moment.tz(ianaTimezone);
  const date = momentTimezone.format("YYYY-MM-DD");
  const time24 = momentTimezone.format("HH:mm");
  const time12 = momentTimezone.format("h:mm A");
  const offset = momentTimezone.utcOffset();
  return {
    date,
    time24,
    time12,
    offset,
    display: ianaTimezone,
    timezone,
  };
};

export { TIMEZONE_MAP };
